module.exports = __webpack_public_path__ + "static/media/layout4-vid.a997d29f.svg";